import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { GbStripeService } from 'libs/gb-front/payment/data-access-stripe/src/lib/gb-stripe.service'
import { take, withLatestFrom } from 'rxjs'
import { GbPaymentService } from '../gb-payment.service'
import { GbFrontDialogService } from 'libs/gb-front/shared/util/src'
import { GbPaymentDialogConfig } from '../gb-payment.models'
import { CustomerPaymentMethodsFacade } from 'libs/gb-front/payment/data-access-customer-payment-methods/src/lib/+state/customer-payment-methods.facade'
import * as AuctionActions from 'libs/gb-front/auction/data-access/src/lib/+state/auction.actions'
import * as CustomerPaymentMethodsActions from 'libs/gb-front/payment/data-access-customer-payment-methods/src/lib/+state/customer-payment-methods.actions'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.facade'
import { PaymentProcessEnum } from 'libs/gb-front/auction/data-access/src/lib/+state/payment-methods.models'

@UntilDestroy()
@Component({
  selector: 'gb-payment-dialog',
  templateUrl: './gb-payment-dialog.component.html',
  styleUrls: ['./gb-payment-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbPaymentDialogComponent implements OnInit, OnDestroy {
  paymentSessionExpired$ = this.gbPaymentService.paymentSessionExpired$

  constructor(
    @Inject(MAT_DIALOG_DATA) public paymentDialogData: GbPaymentDialogConfig,
    private gbPaymentService: GbPaymentService,
    private gbStripeService: GbStripeService,
    private gbFrontDialogService: GbFrontDialogService,
    private auctionFacade: AuctionFacade,
    private customerPaymentMethodsFacade: CustomerPaymentMethodsFacade,
  ) {}

  ngOnInit(): void {
    this.gbPaymentService.initPayment(this.paymentDialogData)
    this.auctionFacade.dispatch(
      AuctionActions.initSelectedPaymentMethod({ paymentAmount: this.paymentDialogData.paymentAmount }),
    )
    this.customerPaymentMethodsFacade.dispatch(
      CustomerPaymentMethodsActions.loadCustomerPaymentMethods({ setCardSelected: true }),
    )

    if (this.paymentDialogData.paymentAmount) {
      this.subscribeToStripeChanges()
    }
  }

  ngOnDestroy(): void {
    this.gbPaymentService.clearPayment()
  }

  subscribeToStripeChanges(): void {
    this.gbStripeService.stripeConnectUpdated$
      .pipe(untilDestroyed(this), withLatestFrom(this.auctionFacade.paymentMethodsByAuthProfile$))
      .subscribe(([, paymentMethodsByAuthProfile]) => {
        if (
          !paymentMethodsByAuthProfile.find(
            (paymentMethod) => paymentMethod.payment_process !== PaymentProcessEnum.Stripe,
          )
        ) {
          this.gbFrontDialogService.closeDialog(GbPaymentDialogComponent)
        }
      })
  }
}
